import React, { useState, useEffect } from "react";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import useTable from "../../useTable";
import { ActualizarConsultarVerificacionPagosWeb } from "./modalActualizarConsultarVerificacion";
import axios from "axios";
import { SearchInput } from "../../../ui/inputs/Input";

const headCells = [
  {
    id: "idcomercio",
    label: "CODIGO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "white",
  },
  {
    id: "ritm",
    label: "RITM",
    width: "60px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "white",
  },
  {
    id: "rif",
    label: "RIF",
    width: "60px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "white",
  },
  {
    id: "nombre",
    label: "NOMBRE",
    width: "300px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "white",
  },
  {
    id: "reprelegal",
    label: "CEDULA ",
    width: "80px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "white",
  },
  {
    id: "accion",
    label: "OPCIONES",
    width: "60px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "white",
  },
];

function TablaComercio2(props) {
  const [titulo1] = useState();
  const [msg1] = useState();
  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [comercio, setComercio] = useState();
  const [persona, setPersona] = useState();
  const [statusCome, setStatusCome] = useState();
  const [configCome, setConfigCome] = useState();
  const [actividad, setActividad] = useState();
  const [inmuebleCome, setInmuebleCome] = useState();
  const [usuariow, setUsuariow] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [facturasC] = useState();
  const [pagow, setPagow] = useState();
  const [retencion, setRetencion] = useState();
  const [multas, setMultas] = useState();
  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [anioActu] = useState(localStorage.getItem("anioactu"));
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [permiso, setPermiso] = useState();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              (x.idcomercio.includes(target.value) === null
                ? ""
                : x.idcomercio.includes(target.value)) ||
              (x.ritm === null
                ? ""
                : x.ritm.toLowerCase().includes(target.value.toLowerCase())) ||
              (x.rif === null
                ? ""
                : x.rif.toLowerCase().includes(target.value.toLowerCase())) ||
              (x.nombre === null
                ? ""
                : x.nombre
                    .toLowerCase()
                    .includes(target.value.toLowerCase())) ||
              (x.reprelegal === null ? "" : x.reprelegal.includes(target.value))
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setPermiso(JSON.parse(localStorage.getItem("permisos")).acccontribuyente);
    setFechaSistema(obj.fechasistema);
    setEspiritu(obj.espiritu);
    seleccionarComercios();
    seleccionarStatus();
    seleccionarConfiguracion();
  }, []);

  const seleccionarComercios = () => {
    setActivate(true);
    setRecords([]);
    let endpoint = `${op.conexion}/api/industria/comercios`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
          }
        }
        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
        setActivate(false);
      });
  };

  const seleccionarConfiguracion = () => {
    let endpoint = op.conexion + "/api/industria/configuracionindustria";
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setConfigCome(response.data);
          if (response.data.valorutMulta === null) {
            if (response.data.factormulta === 2) {
              setMensaje({
                mostrar: true,
                titulo: "Información",
                texto:
                  "El valor de la unidad tributaria para el año " +
                  anioActu +
                  " no esta definido",
                icono: "informacion",
              });
            } else if (response.data.factormulta > 2) {
              let tipo = response.data.factormulta - 3;
              setMensaje({
                mostrar: true,
                titulo: "Información",
                texto:
                  "El valor del " +
                  (tipo === 0
                    ? "Petro"
                    : tipo === 1
                    ? "Sueldo Minimo"
                    : tipo === 2
                    ? "UCAMP"
                    : "") +
                  " para el año " +
                  anioActu +
                  " en el mes en curso no esta definido",
                icono: "informacion",
              });
            }
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
        setActivate(false);
      });
  };

  const seleccionarStatus = () => {
    let endpoint = op.conexion + "/api/efiscal/status";
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          var come = [];
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].tipostatus.trim() === "COMERCIO") {
              come.push({
                idstatus: response.data[i].idstatus,
                descripcion: response.data[i].descripcion,
              });
            }
            setStatusCome(come);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
        setActivate(false);
      });
  };

  const SelectComercio = (idcomercio) => {
    let endpoint = `${op.conexion}/api/industria/comerciopersona/${idcomercio}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.idcomercio > 0) {
            setPersona({
              cedula: response.data.cedula,
              nombres: response.data.nombres,
              apellidos: response.data.apellidos,
              correoe: response.data.correoe,
              tlf1: response.data.tlf1,
              tlf2: response.data.tlf2,
              fnacimiento: response.data.fnacimiento,
              nacionalidad: response.data.nacionalidad,
              sexo: response.data.sexo,
              direccion: response.data.direccionp,
            });
            setComercio(response.data);
            let idactividad =
              response.data.idactividad === null
                ? 0
                : response.data.idactividad;
            let idinmueble =
              response.data.idinmueble === null ? 0 : response.data.idinmueble;
            SelectActividad(idcomercio, idactividad, idinmueble);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "ERROR",
              texto: "error al cargar el comercio",
              icono: "error",
            });
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
        setActivate(false);
      });
  };

  const SelectActividad = (idcomercio, idactividad, idinmueble) => {
    let endpoint = `${op.conexion}/api/industria/actividad?idactividad=${idactividad}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setActividad(response.data);
          }
          SelectActividadComercio(
            idcomercio,
            parseInt(localStorage.getItem("efiscalanio")),
            idinmueble
          );
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
        setActivate(false);
      });
  };

  const SelectActividadComercio = (idcomercio, anio, idinmueble) => {
    let endpoint = `${op.conexion}/api/industria/actividadxcomercio?idcomercio=${idcomercio}&anio=${anio}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            var axc = [];
            for (let i = 0; i < response.data.length; i++) {
              axc.push({
                alicuota: response.data[i].alicuota,
                codigoactividad: response.data[i].codigoactividad,
                codigociu: response.data[i].codigociu,
                descripcion: response.data[i].descripcion,
                idactividad: response.data[i].idactividad,
                minimo: response.data[i].minimo,
              });
            }
          }
          SelectUsuarioWeb(idcomercio, idinmueble);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
        setActivate(false);
      });
  };

  const SelectUsuarioWeb = (idcomercio, idinmueble) => {
    let endpoint = `${op.conexion}/api/industria/usuariowebxcomercio?idcomercio=${idcomercio}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            var uw = [];
            for (let i = 0; i < response.data.length; i++) {
              uw.push({
                idusuarioweb: response.data[i].idusuarioweb,
                login: response.data[i].login,
                nombre: response.data[i].nombre,
              });
            }
            setUsuariow(uw);
          }
          SelectInmueble(idinmueble, idcomercio);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
        setActivate(false);
      });
  };
  const SelectInmueble = (idinmueble, idcomercio) => {
    let endpoint = `${op.conexion}/api/industria/inmueblexcomercio?idinmueble=${idinmueble}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setInmuebleCome(response.data);
          }
          SelectDeudaC(idcomercio, fechaSistema, espiritu);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
        setActivate(false);
      });
  };

  const SelectDeudaC = (idcomercio, fecha, espiritu) => {
    let endpoint = `${
      op.conexion
    }/api/industria/deudacomercio?idcomercio=${idcomercio}&fecha=${fecha}&espiritu=${espiritu}&tipounid=${1}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          var his = [];
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                retenciones: response.data[i].retencion,
                credito: response.data[i].acreditacion,
                totalperi: response.data[i].subtotal,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                nummes: response.data[i].nmes,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            }
          }
          setDeuda(deu);
          setHistorico(his);
          SelectPagoWeb(idcomercio);
          console.log(deu);
          console.log(his);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
        setActivate(false);
      });
  };

  const SelectPagoWeb = (idcomercio) => {
    let endpoint = `${op.conexion}/api/industria/pagoswebcomercio?idcomercio=${idcomercio}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setPagow(response.data);
        }
        seleccionarRetenciones(idcomercio);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
        setActivate(false);
      });
  };

  const seleccionarRetenciones = (idcomercio) => {
    let endpoint = `${op.conexion}/api/industria/retencionesxagente?idcomercio=${idcomercio}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRetencion(response.data);
          seleccionarMultas(idcomercio);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
        setActivate(false);
      });
  };

  const seleccionarMultas = (idcomercio) => {
    let camp = "idmulta, fechamulta, descripcion, concepto, monto, cancelada";
    let tabla = "multa";
    let nombreid = "idcontribuyente";
    let nombreid2 = "tablacontribuyente";
    let valorid2 = "comercio";
    let nombreid3 = "tipoimpuesto";
    let valorid3 = "ACTIVIDADES ECONOMICAS";
    let endpoint = `${op.conexion}/api/consulta/modeli3string?campos=${camp}&id=${idcomercio}&nomtab=${tabla}&nomid=${nombreid}&nomid2=${nombreid2}&id2=${valorid2}&nomid3=${nombreid3}&id3=${valorid3}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMultas(response.data);
          setActivate(false);
          setMostrar5(true);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
        setActivate(false);
      });
  };

  const cerrarModalActualizar = () => {
    setComercio();
    setActividad();
    setInmuebleCome();
    setUsuariow();
    setPersona();
    setMostrar5(false);
    renderizar();
  };

  const validarActuComercio = () => {
    if (operacion === 4) {
      setComercio();
      setMostrar5(false);
      return;
    }
    if (operacion === 1) {
    }
    setComercio();
    setActividad();
    setInmuebleCome();
    setUsuariow();
    setPersona();
    setMostrar5(false);
    window.location.href = "/comercio";
  };

  const renderizar = () => {
    seleccionarComercios();
  };
  const consultarComercio = (id, index) => (event) => {
    event.preventDefault();
    setDeshabilitado(true);
    setOperacion(4);
    setActivate(true);
    SelectComercio(id, recordsAfterPagingAndSorting()[index].reprelegal);
  };

  const cerrar = () => {
    props.setTabla(0);
  };

  return (
    <div className="col-8 mx-auto mt-5 m-0 p-2 border rounded">  
        <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top azulGradiant text-light">
            <h3 className="fw-bold m-0">Consultas de Verificaciones Web</h3>
            <a type="button" onClick={cerrar} className="text-light fw-bold fs-6">
            Salir <i className="fas fa-times ms-2"></i>
            </a>
        </header>
        <div className="col-6 col-lg-4 m-0 my-2 p-0">
            <SearchInput
                placeholder="Buscar"
                onChange={handleSearch}
            />
        </div>
        <div className="col-12 m-0 p-0">
            <TblContainer>
                <TblHead />

                <tbody>
                {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                    <tr key={item.idcomercio} style={{ padding: "0" }}>
                        <td
                        className="align-baseline"
                        style={{ textAlign: "center" }}
                        >
                        {item.idcomercio}
                        </td>
                        <td
                        className="align-baseline"
                        style={{ textAlign: "center" }}
                        >
                        {item.ritm}
                        </td>
                        <td
                        className="align-baseline"
                        style={{ textAlign: "center" }}
                        >
                        {item.rif}
                        </td>
                        <td
                        className="align-baseline"
                        style={{ textAlign: "left" }}
                        >
                        {item.nombre}
                        </td>
                        <td
                        className="align-baseline"
                        style={{ textAlign: "center" }}
                        >
                        {item.reprelegal}
                        </td>
                        <td
                        align="center"
                        className="align-baseline"
                        style={{ textAlign: "center" }}
                        >
                        <button
                            style={{
                            pointerEvents:
                                permiso && permiso.substring(0, 1) !== "1"
                                ? "none"
                                : "",
                            }}
                            onClick={consultarComercio(
                            item.idcomercio,
                            index
                            )}
                            title="Consultar Verificación"
                            className="btn btn-sm btn-info rounded-circle"
                        >
                            <i className="fas fa-eye"></i>{" "}
                        </button>
                        </td>
                    </tr>
                    ))}
                </tbody>
            </TblContainer>
            <TblPagination />
        </div>
      <ActualizarConsultarVerificacionPagosWeb
        show={mostrar5}
        titulo={titulo1}
        mensaje={msg1}
        onHideCancela={cerrarModalActualizar}
        onHideAcepta={validarActuComercio}
        actividad={actividad}
        comercio={comercio}
        statuscome={statusCome}
        usuarioweb={usuariow}
        actividadcome={actividad}
        representante={persona}
        tabdeuda={deuda}
        tabpago={historico}
        tabfacC={facturasC}
        tabpagow={pagow}
        tabreten={retencion}
        tabmulta={multas}
        inmueble={inmuebleCome}
        deshabilitado={deshabilitado ? deshabilitado : undefined}
        operacion={operacion}
        espiritu={espiritu}
        declaweb={configCome ? configCome.declaweb.toString() : "false"}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
}

export default TablaComercio2;
